@use "@flixbus/honeycomb-react/dist/scss/honeycomb-helpers.scss";

.bodyContainer {
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-4);
}

.formContainer {
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-4);
}

.perMonthSection {
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-2);
  padding-block: var(--hcr-spacing-1);
  overflow-x: auto;
}

.perMonthRow {
  display: flex;
  align-items: flex-end;
  gap: var(--hcr-spacing-2);
  min-height: calc(2 * var(--hcr-line-height-primary));
}

.variableLabel {
  min-width: 218px;
  width: 218px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: var(--hcr-input-height-desktop);
  transform: translateY(var(--hcr-spacing-2));
}

.monthInputs {
  display: flex;
  gap: var(--hcr-spacing-2);
}

.monthInput {
  width: 60px;
  flex-shrink: 0;

  > [role="alert"] {
    width: max-content;
    max-width: 160px;
    white-space: nowrap;
  }
}

.januaryInput :global([class*="hcr-input__container"]) {
  border-color: var(--hcr-ui-primary-color);

  &:focus-within {
    border-color: var(--hcr-ui-primary-dark-color);
  }

  :global([class*="hcr-input__field"]) {
    &:focus,
    &:focus-visible {
      outline: none;
      box-shadow: none;
    }
  }
}

.januaryCell {
  position: relative;
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;

  :global([class*="hcr-input"]) > [role="alert"] {
    position: absolute;
    top: 100%;
    left: 0;
  }
}

.januaryCell:has(button:not(:disabled):is(:hover, :focus-visible))
  ~ .monthInput
  :global([class*="hcr-input__container"]) {
  border-style: dashed;
  border-color: var(--hcr-ui-primary-color);
  background-color: var(--hcr-highlight-color);
}

.perMonthGroup {
  display: flex;
  flex-direction: column;
  gap: var(--hcr-spacing-1);
}

.pasteTip {
  margin: 0;
  color: var(--hcr-content-secondary-color);
}

.singleInputGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--hcr-spacing-2);
}
